import { Participant } from 'twilio-video';

import { UserWithProfile } from '@uplift/api';
import { formatUserFullName } from '@uplift/utils';

export const getParticipantNameAndInitials = (patient?: UserWithProfile | null, provider?: UserWithProfile | null, participant?: Participant) => {
  let name = '';
  let initials = '';

  if (patient && provider && participant) {
    if (provider.user.id === participant.identity) { // provider name
      name = formatUserFullName({
        firstName: provider.user.firstName,
        lastName: provider.user.lastName,
        preferredFirstName: provider?.profile?.preferredName,
        fallback: provider.user.email,
      });
    } else if (patient.user.id === participant.identity) { // patient name
      name = formatUserFullName({
        firstName: patient.user.firstName,
        lastName: patient.user.lastName,
        preferredFirstName: patient?.profile?.preferredName,
        fallback: patient.user.email,
      });
    }
  }

  if (name) {
    initials = name.slice(0, 1).toUpperCase();
  }

  return { name, initials };
};
